<script setup lang="ts">
import type { KjdsListPageProps } from '@/types/appTypes'

const props = withDefaults(defineProps<KjdsListPageProps>(), {})

console.log('article: kjdsPageConfig', props.kjdsPageConfig)

const baseTitle = '美術館・博物館'
let headTitle = baseTitle

const app = useNuxtApp()
const route = useRoute()
const storeArticleList = useStoreArticleList()
const storeIndex = useStoreIndex()

const pageData = {
  tags: [] as ArticleTag[],
  category: [] as ArticleCategory[],
  items: [] as Article[],
  articleObjects: [] as ArticleObject[],
  meta: {} as ApiMeta,
}

const sortInfo = storeArticleList.getPageSortInfo(props.kjdsPageConfig)
const modelSort = ref(sortInfo?.defaultValue || 'pv_last_week')
if (route.query.sort) {
  modelSort.value = route.query.sort as string
}

const articleName = ref(props.kjdsPageConfig.articleTypeSlug)

const setHead = () => {
  let areaName = ''

  if (route.query.area) {
    areaName = app.$getQueyAreaName(route.query.area as string)
  }

  let headDescription = ''
  let items = []
  if (areaName) {
    headTitle = `${areaName}の${baseTitle}`
    headDescription = `日本最大級のミュージアム情報サイト、アイエム［インターネットミュージアム］による、${areaName}の美術館・博物館のご紹介ページ。施設情報や展覧会の予定など。チケットプレゼントがある時も。美術館・博物館に出かける前に、アイエムをチェック！`
    items = [
      {
        text: baseTitle,
        disabled: false,
        to: { path: '/event' },
      },
      {
        text: headTitle,
        disabled: true,
      },
    ]
  } else {
    headTitle = baseTitle
    headDescription = '日本最大級のミュージアム情報サイト、アイエム［インターネットミュージアム］による美術館・博物館の紹介。約8000館のミュージアムから、館名、地域、ジャンルなどで検索できます。美術館・博物館はアイエムで！'
    items = [
      {
        text: baseTitle,
        disabled: false,
        to: { path: '/event' },
      },
    ]
  }
  storeIndex.setBreadCrumbs(items)

  const headInput = app.$makeMeta({
    title: headTitle,
    description: headDescription,
  })
  useHead(headInput)
}

const onChangeSort = (val) => {
  modelSort.value = val
  const query = { ...route.query }
  if (val) {
    query.sort = val
  } else {
    delete query.sort
  }
  navigateTo({
    path: route.path,
    query,
  })
}

const initPage = async () => {
  const options: KjdsFetchListOptions = { query: { ...route.query } }

  // エリアクエリーがある場合はエリアIDを展開
  // そのために先にmasterをfetchしておく
  if (route.query.area) {
    const areaQuery = route.query.area as string
    const ary = areaQuery.split('-')
    if (ary.length === 2) {
      const val = Number(ary[1])
      if (ary[0] === 'area') {
        const areaId = val - 0
        await storeIndex.fetchMaster()
        const masterArea = storeIndex.state.master.prefecture_area.details
        masterArea.some((area) => {
          if (area.id === areaId) {
            options.query['prefecture'] = area.value
            return true
          }
          return false
        })
      } else if ((ary[0] === 'pref')) {
        options.query['prefecture'] = ary[1]
      }
    }
  }

  const [_resSite, _resMaster, resCategory, resList, resTags] = await Promise.all([
    storeIndex.fetchSite(),
    storeIndex.fetchMaster(),
    storeArticleList.fetchCategories(props.kjdsPageConfig.articleTypeSlug),
    storeArticleList.fetchList(props.kjdsPageConfig.list.mainListName, options),
    storeArticleList.fetchTags(articleName.value),
  ])

  pageData.category = resCategory.data.Categories

  pageData.items = resList.data.articles as Article[]
  pageData.articleObjects = resList.data.article_objects
  pageData.meta = resList.meta

  pageData.tags = resTags.data

  console.log('article: initPage', pageData)
}
await initPage()
setHead()
</script>

<template>
  <div class="p-articlePage">
    <h2 class="c-heading_page">
      {{ headTitle }}
    </h2>

    <SearchPanel
      v-bind:article-name="articleName"
      v-bind:categories="pageData.category"
      v-bind:tags="pageData.tags"
      v-bind:query="route.query"
    />

    <div class="p-articlePage_result">
      <div
        class="c-listHeader"
      >
        <div class="c-listHeader_col">
          <div class="c-listHeader_col_contentSearch">
            全 {{ pageData.meta.count.toLocaleString() }}件
          </div>
        </div>
        <div class="c-listHeader_dropDown">
          <v-select
            v-model="modelSort"
            class="IMCustomOverflowButton marginLeft c-searchSort"
            v-bind:items="sortInfo.items"
            hide-details
            variant="outlined"
            density="comfortable"
            v-on:update:model-value="onChangeSort"
          />
        </div>
      </div>

      <template
        v-if="!pageData.items?.length"
      >
        <div class="p-articlePage_empty">
          お探しの情報は見つかりませんでした
        </div>
      </template>

      <div class="p-articlePage_list">
        <MuseumItem
          v-for="item in pageData.items"
          v-bind:key="item.id"
          v-bind:item="item"
          v-bind:objects="pageData.articleObjects"
        />
      </div>

      <template
        v-if="pageData.items?.length"
      >
        <Pagination
          v-bind:page="pageData.meta.page_no"
          v-bind:length="pageData.meta.total_page"
        />
      </template>

      <SearchList
        path="/museum"
      />
    </div>
  </div>
</template>
